import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { AircraftComponents } from '../aircraft/types'
import { AxiosResponse } from 'axios'
import { useSnackbar } from 'notistack'
import { axios } from '../api'
import { Button, Grid, Menu, MenuItem} from '@mui/material'
import { DataGridPremium, GridColDef,  /* GridCsvExportMenuItem, */  GridRowSelectionModel,  /* GridToolbarColumnsButton,  GridToolbarContainer,  GridToolbarDensitySelector,  GridToolbarExportContainer,  GridToolbarFilterButton, */ } from '@mui/x-data-grid-premium'
import LoadingSpinner from '../components/Loading'
import { useConfig } from '../hooks/useConfig'
import CustomFilterPanelPremium from '../components/CustomFilterPanelPremium'
import { DueDateDetailView } from './type'
import {  CreateFab2 } from '../components/Buttons'
import DuedateParentSliderForm from './DuedateParentSliderForm'
import ContentBox from '../components/DatagridProContnet'
import { ActionMenuItem } from '../components/datagrid/ActionMenu'
import { bindTrigger } from 'material-ui-popup-state'
import { bindMenu, usePopupState } from 'material-ui-popup-state/hooks'
import { Link, useNavigate } from 'react-router-dom'
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { commonDataGridPremiumSx } from '../utils/dataGridSx'
import { daysRemainingUntilDue } from './dueDateDates'
import { whiteboardStatusLabel, whiteboardStatusOptions } from './whiteboardStatus'
import { actionsMenuButtonSx } from "../components/dropdownMenuStyles";

interface LinkedRecordsProps {
    duedate:DueDateDetailView;
  canEdit:boolean;
}


interface ActionMenuButtonProps {
  onClick?: (event: any) => any;
  actions?: ActionMenuItem[];
  disabled?: boolean;
}

const ActionMenu: React.FC<ActionMenuButtonProps> = (
  props: ActionMenuButtonProps
) => {
  const { actions, disabled } = props;
  const popupState = usePopupState({
      variant: "popover",
      popupId: "action-menu",
  });

  return (
      <>
          <ActionMenuButton disabled={disabled} {...bindTrigger(popupState)} />
          <Menu {...bindMenu(popupState)}>
              {actions?.map((action, index) => {
                  if (action.to) {
                      return (
                          <MenuItem
                              onClick={() => popupState.close()}
                              component={Link}
                              to={action.to}
                              key={index}
                          >
                              {action.name}
                          </MenuItem>
                      );
                  }
                  return (
                      <MenuItem
                          key={index}
                          onClick={() => {
                              popupState.close();
                              if (action.onClick) {
                                  action.onClick();
                              }
                          }}
                      >
                          {action.name}
                      </MenuItem>
                  );
              })}
          </Menu>
      </>
  );
};

const ActionMenuButton: React.FC<ActionMenuButtonProps> = (
  props: ActionMenuButtonProps
) => {
  const { onClick, disabled } = props;

  return (
      <Button
          disabled={disabled}
          aria-controls="options-menu"
          aria-haspopup="true"
          onClick={onClick}
          sx={actionsMenuButtonSx}
          variant="contained"
          endIcon={<KeyboardArrowDownIcon />}
      >
          ACTIONS
      </Button>
  );
};



const LinkedRecords: React.FC<LinkedRecordsProps> = (props) => {
    const {enqueueSnackbar} = useSnackbar()
  const {duedate, canEdit} = props
    const [linkedRecords,setLinkedRecords] = useState<AircraftComponents[]>()
    const [open,setOpen] = useState(false);
    const dueDateConfig =useConfig("whiteboard")
    const navigate = useNavigate();
    const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);
        const [onchangeRow, setOnchangeRow] = useState<AircraftComponents[]>([]);
        const [rows, setRows] = useState<AircraftComponents[]>([]);
    const statusOptions = useMemo(() => whiteboardStatusOptions(dueDateConfig), [dueDateConfig]);

    const columns: GridColDef[] = useMemo(
        () => [
            {
                headerName:"ID",
                field:"id",
                flex:0.5
            },
            {
                headerName:"Status",
                field:"status",
                flex:0.5,
                type: "singleSelect",
                filterable:true,
                valueOptions: statusOptions,
                // DataGridPremium 7: the formatter receives (value, row).
                valueFormatter: (value) => whiteboardStatusLabel(dueDateConfig, value),
                valueGetter: (params,row) => row?.status,
            },
            {
                headerName:"Last Done",
                field:"last_done",
                flex:0.5,
                filterable:false
            },
            {
                headerName:"Code",
                field:"title",
                flex:0.5,
                filterable:false
            },
            {
                headerName:"Section",
                field:"section",
                flex:0.5,
                filterable:false,
                valueGetter:(params,row)=> row?.section?.name
            },
            {
                headerName:"Type",
                field:"type_id",
                flex:0.5,
                filterable:false,
                valueGetter:(params,row)=> row?.type_obj?.name
            },
            {
                headerName:"Comment",
                field:"comment",
                flex:0.5,
                filterable:false
            },
            {
                headerName:"User",
                field:"user",
                flex:0.5,
                filterable:false,
                valueGetter:(params,row)=> row?.user_obj?.gecos
            },
            {
                headerName:"Due Date",
                // DueDateList serves the due date as `required` (no `due_date`), as
                // DueDateDataGrid reads it. DataGridPremium 7: valueGetter(value, row).
                field:"required",
                flex:0.5,
                filterable:false,
                valueGetter: (_value, row) => row?.required ?? row?.due_date ?? ""
            },
            {
                headerName:"Remaining",
                field:"remaining",
                flex:0.5,
                filterable:false,
                align: "right",
                headerAlign: "right",
                // DataGridPremium 7: valueGetter(value, row). Reading params.row
                // blanked every cell; the BE serves `remaining` from `required`.
                valueGetter: (_value, row) => {
                  if (row?.remaining != null && row.remaining !== "") {
                    return row.remaining;
                  }
                  return daysRemainingUntilDue(row?.required ?? row?.due_date ?? null) ?? "";
                },
            },
    
         
        ],
        [dueDateConfig,statusOptions]
      );

    const getData = useCallback(
        async () => {
            try {
              const resp: AxiosResponse =
                await axios.get(`/v6/duedate/linked_records/${duedate?.id}`, {
                    id:`get-linked-records-${1}`
                });
               axios.storage.remove(`get-linked-records-${1}`)
               setLinkedRecords(resp.data)
               setRows(Array.from(resp.data));
            } catch (e) {
              // @ts-ignore
              if (!axios.isCancel(e)) {
                enqueueSnackbar("Error fetching Linked Records", {
                  variant: "error",
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center",
                  },
                });
              }
              throw e;
            }
          },[enqueueSnackbar,duedate?.id])

          useEffect(()=>{
            getData()
          },[getData])


/* const GridToolbarExport = ({
  ...other
}) => (
  <GridToolbarExportContainer {...other}>
        <ListSubheader className='list-subheader-item'>Export</ListSubheader>
        <GridCsvExportMenuItem  options={{
          fileName:"Linked-Records"
        }} />

  </GridToolbarExportContainer>
);
   
function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{
      display:"flex",
      justifyContent:"space-between"
    }}>
      <Box>
      <GridToolbarFilterButton slotProps={{
        button:{
          sx:{
            color: "#616161 !important",
            fontSize:"1rem !important",
            marginRight:"30px !important"
          }
        }
      }}/>
      <GridToolbarColumnsButton  slotProps={{
        button:{
          sx:{
            color: "#616161 !important",
            fontSize:"1rem !important",
            marginRight:"30px !important"
          }
        }
      }}/>
      <GridToolbarDensitySelector  slotProps={{
        button:{
          sx:{
            color: "#616161 !important",
            fontSize:"1rem !important",
            marginRight:"30px !important"
          }
        }
      }}/>
      </Box>
      <Box>
      <GridToolbarExport slotProps={{
        button:{
          sx:{
            color: "#616161 !important",
            fontSize:"1rem !important",
            marginRight:"30px !important"
          }
        }
      }}  {...props} />
      <Button sx={{
          color:"#616161",
          fontSize:"1rem"
      }}>
      <PictureAsPdfIcon /> <span style={{marginLeft:"10px"}}>PRINT</span>
      </Button></Box>
    </GridToolbarContainer>
  );
} */

const actions = useMemo<ActionMenuItem[]>(() => {
  // if (!canEdit) {
  //   return [];
  // }

  return [
      {
        name: 'Edit Duedate',
        namePlural: "Edit Duedate",
        action: ["EditDuedate", 'EDIT_DUEDATE'],
        requiresSelection: true,
        isReturnDataSelection: true,
        onClick: async (event: any) => {
          console.log(onchangeRow,"rows")
          if (onchangeRow?.length === 1) {
              navigate(`/duedate/${onchangeRow[0]?.id}`)
          }
        }
      },
  ];
}, [navigate, onchangeRow]);   


  return (
    <>
  
      <ContentBox>
      <Grid container rowSpacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                    {true ? <>
                    <CreateFab2
                    onClick={()=>{
                      setOpen(true)
                    }} 
                    size='small' 
                    key={1} />      
                    <ActionMenu key={2} actions={actions} />
                    </> : null}             
                </Grid>

                
            </Grid>
            {
      linkedRecords ?
      <DataGridPremium
        columns={columns}
        rows={linkedRecords}
        checkboxSelection={canEdit}
        autoHeight
        slots={{ // toolbar: CustomToolbar ,
          filterPanel:CustomFilterPanelPremium
          }}
        initialState={{
          density: 'compact',
        }}
        sx={{
          ...commonDataGridPremiumSx,
          "& .MuiDataGrid-toolbarContainer": {
            paddingTop: "10px",
            paddingBottom: "10px"
          }
        }}
        hideFooterRowCount
        hideFooter
        onRowSelectionModelChange={(newRowSelectionModel: any) => {
          setRowSelectionModel(newRowSelectionModel);
          const selectedRows = rows.filter((row) =>
              newRowSelectionModel.includes(row.id)
          );
          setOnchangeRow(selectedRows);
      }}
      rowSelectionModel={rowSelectionModel}
      />:<LoadingSpinner/>
    }
        </ContentBox>
        <DuedateParentSliderForm  open={open} onClose={()=>{
          setOpen(false)
          getData()
        }} duedate_id={duedate?.id||0}/>
    </>
  )
}

export default LinkedRecords